
<div class="content-section">
  <app-trial-license-warning></app-trial-license-warning>
  <lib-campaigns></lib-campaigns>
  <div class="title-div">
    <div class="col p-0 d-flex justify-content-between align-items-center changeInstitution">

        <div class="col-11 p-0">
          <a class="back_bd" (click)='emitData("backToElearning")'>
            <img class="svg mr-2" src="assets/ph-bhp-layout/svg/back.svg" /> {{ translationKeys.SOPObservation.Back | translate}}</a
          >
          <h2 class="background_title">{{ "E_LEARNING.PUZZLE" | translate }}</h2>
        </div>
    </div>
  </div>
  <div class="container-fluid alone ">
    <h2 class="section-title">{{ "E_LEARNING.SELECT_SOP" | translate }}</h2>

    <div class="container-cards">

      <div class="col-12  my-3" *ngFor="let sopDatail of sopDatails; let i = index"  (click)="openSOP(sopDatail.sopid)">
        <div class="row card_bd_inline">
            <div class="col-2 p-0 card_media_inline_bd">
              <div class="row">
                  <div class="col-12 text-center">
                      <img  [src]="
                      sopDatail.sopImage
                        ? layoutService.serverUrl + sopDatail.sopImage
                        : 'assets/ph-bhp-layout/svg/no-image.png'
                    " alt="Tu Imagen" class="img-fluid">
                  </div>
              </div>
            </div>

          <div class="col-10 card_content_inline_bd">
            <div class="col-12
             card-title">
              <h5 class="mt-2 card-title-inline">
                {{
                  layoutService.translateText(sopDatail.title) | labelSanitizer
                }}
              </h5>
              <p class="mb-0 card-subtitle-inline">
                {{
                  layoutService.translateText(sopDatail.description)
                    | translate
                    | labelSanitizer
                }}
              </p>
          </div>
          <div class="col-12 d-flex justify-content-end">
            <button type="button" class="btn-continue-bordered-bd">{{ "SOP_OBSERVATION.START_NEW_OBSERVATION" | translate}}</button>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</div>
